import React from 'react';
import { string, number, object, func } from 'prop-types';
import { noop } from 'lodash';
import { Rating } from '@fiverr-private/orca';

const RatingWrapper = ({
    className,
    rating = 0,
    ratingsCount,
    onClick = noop,
    theme = Rating.THEMES.FIVE_STARS
}, { general: { isPro } }) => (
    <Rating className={className}
        theme={theme}
        score={parseFloat(rating.toFixed(1))}
        color={isPro ? Rating.COLORS.PRO: Rating.COLORS.YELLOW}
        ratingsCount={ratingsCount}
        onClick={onClick}/>
);

RatingWrapper.propTypes = {
    className: string,
    rating: number,
    ratingsCount: number,
    theme: string,
    onClick: func
};

RatingWrapper.contextTypes = {
    general: object
};

export default RatingWrapper;
